import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {compose} from 'redux';

import Sidebar from '../common/Sidebar';
import TopbarMobile from '../common/TopbarMobile';
import {WrapperBlock, PageBlock, PageInnerBlock} from '../common/MainBlocks';
import {Toolbar, Title, Description} from './styles';

const allowedRoles = ['administrator', 'rental-manager'];

function Layout({authorization, children, description, history, loggedIn, role, title}) {
  React.useEffect(() => {
    if (!loggedIn || !allowedRoles.includes(role)) {
      history.replace('/');
    }
  }, [history, loggedIn, role]);

  if (!loggedIn || !allowedRoles.includes(role)) {
    return null;
  }

  return (
    <WrapperBlock>
      <TopbarMobile />
      <Sidebar />
      <PageBlock>
        <PageInnerBlock>
          <Toolbar>
            <div>
              <Title>{title}</Title>
              <Description>{description}</Description>
            </div>
          </Toolbar>
          <div style={{marginTop: 16}}>{React.cloneElement(children, {authorization, role})}</div>
        </PageInnerBlock>
      </PageBlock>
    </WrapperBlock>
  );
}

const mapStateToProps = ({manager}) => ({
  authorization: manager.accessToken && `Bearer ${manager.accessToken}`,
  loggedIn: Boolean(manager.accessToken && manager.data && Object.keys(manager.data).length > 0),
  role: manager.data && manager.data.role,
});

export default compose(connect(mapStateToProps), withRouter)(Layout);
